import {
  Alert,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@mui/material";
import { useState, useEffect, useRef, useMemo } from "react";
import {
  Accordion,
  Button,
  Card,
  Col,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import ApiBasketItemPerson from "../../../core/api/api.basketItemPerson";
import SwalMessage from "../../pages/_Components/SwalMessage";
import _ from "lodash";
import Swal from "sweetalert2";
import { tools } from "../../../core/utils/tools";
import LoaderDot from "../_Components/LoaderDot";
import TicketStatusToUsedResultModal from "./Component/TicketStatusToUsedResultModal";
import TickeInfoBox from "./Component/TickeInfoBox";

import {
  IconMobile,
  IconNoTicket,
  IconTicket1,
  IconUser,
  IconTicket,
} from "../../../_metronic/css/icons";
import { IconInfo } from "./Component/icon";

function TicketSearch() {
  const [tickets, setTickets] = useState([]);
  const [searchTickets, setSearchTickets] = useState();
  const diffrentPrice = useMemo(() => {
    // const shamsiDate = tools.getShamsiDateIntlEnglishNumbers();
    // const checkInDate = searchTickets.basketItemPersons[0]?.checkInDate;
    const diffrentPrice = searchTickets?.supplierSettlementPrice - searchTickets?.basketItemPersons?.[0]?.supplierSettlementPrice;

    return diffrentPrice
  }, [searchTickets])
  const diffrentDate = useMemo(() => {
    const shamsiDate = tools.getShamsiDateIntlEnglishNumbers();
    const checkInDate = searchTickets?.basketItemPersons?.[0]?.checkInDate;

    return {
      checkInDate, isDiffrent: !!searchTickets?.basketItemPersons.length && shamsiDate && checkInDate && shamsiDate != checkInDate
    }
  }, [searchTickets])
  const createdPersianTime = useMemo(() => {
    return searchTickets?.basketItemPersons?.[0]?.createdPersianTime;
  }, [searchTickets])
  const [ticketNumber, setTicketNumber] = useState();
  const [searchTextDisplay, setSearchTextDisplay] = useState();
  const [loadingLastTicket, setLoadingLastTicket] = useState(true);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [displaySearchResult, setDisplaySearchResult] = useState(false);
  const cancelButtonRef = useRef(null); // ایجاد ref برای دکمه "ابطال بلیط"
  const textFieldRef = useRef(null);

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
  } = useForm();
  const fetchAllTickets = async () => {
    setLoadingLastTicket(true);
    try {
      const response = await ApiBasketItemPerson.getAllLastTicket();
      setTickets(response.data);
    } catch (error) {
      SwalMessage({
        title:
          "در حال حاضر امکان برقراری ارتباط با سامانه وجود ندارد، لطفا بعدا دوباره تلاش کنید.",
        iSsuccess: false,
      });
      setLoadingLastTicket(false);
    } finally {
      setLoadingLastTicket(false);
    }
  };
  useEffect(() => {
    (async () => {
      fetchAllTickets();
    })();
    return () => { };
  }, []);

  useEffect(() => {
    textFieldRef.current.focus(); // فوکوس کردن
  }, []);

  useEffect(() => {
    if (displaySearchResult && searchTickets && cancelButtonRef.current) {
      setTimeout(() => {
        cancelButtonRef.current.focus(); // فوکوس کردن
      }, 100);
    }
  }, [displaySearchResult, searchTickets]);

  const fetchTickets = async () => {
    try {
      const response = await ApiBasketItemPerson.getTicketById(ticketNumber);
      setSearchTickets(response.data);
    } catch (error) {
      SwalMessage({
        title:
          "در حال حاضر امکان برقراری ارتباط با سامانه وجود ندارد، لطفا بعدا دوباره تلاش کنید.",
        iSsuccess: false,
      });
    }
  };

  //جست و جوی بلیط
  const onSubmit = async (data) => {
    if (_.isEmpty(data.ticketNumber)) {
      SwalMessage({
        title: "لطفا شماره بلیط مورد نظر را انتخاب نمایید",
        iSsuccess: false,
      });
      return;
    }

    setLoadingSearch(true);
    setTicketNumber(data.ticketNumber);
    setSearchTextDisplay();
    try {
      const response = await ApiBasketItemPerson.getTicketById(
        data.ticketNumber
      );

      if (response?.data?.basketId == 0) {
        setSearchTextDisplay(true);
      } else {
        setSearchTextDisplay(false);
        setSearchTickets(response.data);
        setDisplaySearchResult(true);
        fetchAllTickets();
      }
    } catch (error) {
      SwalMessage({
        title:
          "در حال حاضر امکان برقراری ارتباط با سامانه وجود ندارد، لطفا بعدا دوباره تلاش کنید.",
        iSsuccess: false,
      });
    } finally {
      setLoadingSearch(false);
    }
  };

  // تابعی برای پاک کردن و فوکوس روی TextField
  const resetAndFocusTextField = () => {
    setDisplaySearchResult(false);
    setSearchTickets(null);

    setValue("ticketNumber", "");
    setTimeout(() => {
      textFieldRef.current.focus(); // فوکوس کردن
    }, 100);
  };

  /** قسمت ابطال بلیط ******************/
  const initialCount = searchTickets?.basketItemPersons?.length || 0;
  useEffect(() => {
    if (searchTickets?.basketItemPersons) {
      setSelectedCount(initialCount);
      // مقداردهی اولیه checkedStatus به طول tickets.basketItemPersons
      setCheckedStatus(
        new Array(searchTickets.basketItemPersons.length).fill(true)
      );
    }
  }, [searchTickets]);

  const [selectedCount, setSelectedCount] = useState(initialCount);
  const [checkedStatus, setCheckedStatus] = useState([]);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const handleSelectChange = (e) => {
    const newCount = Number(e.target.value);
    setSelectedCount(newCount);
    // به‌روزرسانی وضعیت چک‌باکس‌ها بر اساس مقدار انتخابی
    const newCheckedStatus = checkedStatus.map((_, index) => index < newCount);
    setCheckedStatus(newCheckedStatus);
  };
  const handleCheckboxChange = (index) => {
    const updatedStatus = [...checkedStatus];
    updatedStatus[index] = !updatedStatus[index];

    // به‌روزرسانی تعداد انتخاب‌شده
    setCheckedStatus(updatedStatus);
    setSelectedCount(updatedStatus.filter(Boolean).length);
  };

  const handleCancel = () => {
    //setShowComponent(false); // مخفی کردن کامپوننت
    setSearchTickets(null);
    setDisplaySearchResult(false);
    setTimeout(() => {
      textFieldRef.current.focus(); // فوکوس کردن
    }, 100);
  };
  const [canceledTickets, setCanceledTickets] = useState([]);
  const [updatedTicket, setUpdatedTicket] = useState();
  const [
    showModalTicketStatusToUsedResult,
    setShowModalTicketStatusToUsedResult,
  ] = useState(false);

  //ابطال بلیط
  const cancelTicket = async () => {
    const checkedTickets = searchTickets?.basketItemPersons?.filter(
      (_, index) => checkedStatus[index]
    );
    const ticketIds = checkedTickets.map((ticket) => ticket.id);
    setCanceledTickets(ticketIds);

    const payload = { Tickets: ticketIds };
    setLoadingBtn(true);

    try {
      const response = await ApiBasketItemPerson.cancelTickets(payload);
      if (response.succeeded) {
        const response2 = await ApiBasketItemPerson.getUsedTicketsByIds(
          payload?.Tickets
        );
        setUpdatedTicket(response2.data);
        setShowModalTicketStatusToUsedResult(true);
      } else {
        SwalMessage({
          title: response.message,
          iSsuccess: response.succeeded,
        });
        setShowModalTicketStatusToUsedResult(false);
        fetchTickets();
      }
    } catch (error) {
      fetchTickets();
    } finally {
      setLoadingBtn(false);
    }
  };

  //    جلوگیری از وارد کردن حروف و فقط اجازه دادن به اعداد فارسی و انگلیسی
  const handleKeyPress = (e) => {
    const regex = /^[0-9۰-۹]$/;
    if (!regex.test(e.key)) {
      e.preventDefault();
    }
  };

  // تابع برای تبدیل عدد فارسی به انگلیسی
  const convertToEnglishNumber = (input) => {
    const persianToEnglish = {
      "۰": "0",
      "۱": "1",
      "۲": "2",
      "۳": "3",
      "۴": "4",
      "۵": "5",
      "۶": "6",
      "۷": "7",
      "۸": "8",
      "۹": "9",
    };

    return input.replace(/[۰-۹]/g, (char) => persianToEnglish[char] || char);
  };
  //    ارسال فرم با فشردن اینتر
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit(onSubmit)();
    }
  };
  const handleClearTicketNumber = () => {
    setValue("ticketNumber", ""); // پاک کردن فیلد شماره بلیط
    clearErrors("ticketNumber");
    setSearchTextDisplay(); // مخفی کردن پیام شماره بلیط معتبر نمی باشد
    if (textFieldRef.current) {
      textFieldRef.current.focus();
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="pb-3">
          <Card>
            <Card.Body className="py-3 px-5">
              <Row>
                <Col className="pr-0">
                  <Controller
                    name="ticketNumber"
                    control={control}
                    rules={{
                      required: true,
                      pattern: {
                        value: /^[0-9۰-۹]+$/,
                        message: "لطفا فقط عدد وارد کنید",
                      },
                      maxLength: {
                        value: 10,
                        message: "حداکثر تعداد ارقام 10 است",
                      },
                      validate: (value) => {
                        const numValue = convertToEnglishNumber(value);
                        const numericValue = parseInt(numValue, 10);
                        return (
                          (!isNaN(numericValue) &&
                            numericValue <= 2147483647) ||
                          "شماره بلیط باید یک عدد صحیح و کمتر از 2,147,483,647 باشد"
                        );
                      },
                    }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="جستجو شماره بلیط"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        style={{ height: "23px" }}
                        error={!!errors.ticketNumber}
                        onChange={(e) => {
                          const englishValue = convertToEnglishNumber(
                            e.target.value
                          );
                          onChange(englishValue);
                          if (englishValue === "") {
                            setSearchTextDisplay();
                          }
                        }}
                        inputProps={{
                          maxLength: 10,
                          onKeyPress: handleKeyPress,
                          onKeyDown: handleKeyDown,
                        }}
                        inputRef={textFieldRef}
                      />
                    )}
                  />
                  <div className="text-danger my-3 fs-small">
                    {errors.ticketNumber?.message}
                  </div>
                </Col>
                <Col xs="auto" className="pl-2 pr-2">
                  {loadingSearch ? (
                    <Button
                      variant="primary"
                      type="submit"
                      style={{ marginTop: "16px", height: "35px" }}
                      disabled
                    >
                      <i className="fas fa-search p-0"></i>
                    </Button>
                  ) : (
                    <Button
                      variant="primary"
                      style={{ marginTop: "16px", height: "35px" }}
                      type="submit"
                    >
                      <i className="fas fa-search p-0"></i>
                    </Button>
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
      </form>
      {/* <TicketStatusToUsedResultModal
        showModalTicketStatusToUsedResult={true}
        setShowModalTicketStatusToUsedResult={
          setShowModalTicketStatusToUsedResult
        }
        updatedTicket={updatedTicket}
        setTickets={setTickets}
        onResetAndFocus={resetAndFocusTextField}
        fetchAllTickets={fetchAllTickets}
      /> */}
      {loadingSearch ? (
        <div className=" bg-white border rounded-3 p-5 shadow-sm mx-auto">
          <LoaderDot text="در حال جستجوی بلیط" />
        </div>
      ) : (
        ""
      )}
      {searchTextDisplay === true ? (
        <Alert
          severity="warning"
          className="rounded-3 my-3 border text-center py-3 align-items-center justify-content-center"
          style={{ fontSize: "14px" }}
        >
          شماره بلیط معتبر نمی باشد!
        </Alert>
      ) : searchTextDisplay === false ? (
        <>
          {showModalTicketStatusToUsedResult && (
            <TicketStatusToUsedResultModal
              showModalTicketStatusToUsedResult={
                showModalTicketStatusToUsedResult
              }
              setShowModalTicketStatusToUsedResult={
                setShowModalTicketStatusToUsedResult
              }
              updatedTicket={updatedTicket}
              setTickets={setTickets}
              onResetAndFocus={resetAndFocusTextField}
              fetchAllTickets={fetchAllTickets}
            />
          )}

          {searchTickets?.basketId > 0 && displaySearchResult && (
            <Card className="rounded-4  border border-secondary">
              <Card.Header className="rounded-top-4 p-4 text-dark-primary bg-light">
                <div className="d-flex justify-content-between  justify-content-sm-start fw-bold acc">
                  <div>
                    <span className="small-svg mr-1">
                      <IconUser />
                    </span>
                    <span>{searchTickets.basketUser} </span>
                  </div>
                  <div className=" ml-sm-5">
                    <span>{searchTickets.userMobile}</span>

                    <span className="small-svg mr-1 d-sm-none">
                      <IconMobile />
                    </span>
                  </div>
                </div>
              </Card.Header>
              <Card.Body className="acc p-3">
                <div className="d-flex justify-content-between ">
                  <div>
                    <Row className="text-green">
                      <Col
                        xs="12"
                        sm
                        className="nowrap text-center my-auto fs-small-1"
                      >
                        <span className="small-svg mr-1">
                          <IconTicket1 />
                        </span>
                        آماده استفاده{" "}
                      </Col>
                      <Col
                        xs="12"
                        sm
                        className="nowrap mt-3 mt-sm-0 text-center"
                      >
                        <div className="bg-green py-1 rounded-2 mx-3 mx-sm-2">
                          <span className="fw-bold mx-1">
                            {searchTickets.bookedTicketCount}
                          </span>{" "}
                          بلیط
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <Row className="text-red">
                      <Col
                        xs="12"
                        sm
                        className="nowrap text-center my-auto fs-small-1"
                      >
                        <span className="small-svg mr-1">
                          <IconTicket />
                        </span>
                        استفاده شده
                      </Col>
                      <Col
                        xs="12"
                        sm
                        className="nowrap mt-3 mt-sm-0 text-center"
                      >
                        <div className="bg-red py-1 rounded-2 mx-3 mx-sm-2">
                          <span className="fw-bold mx-1">
                            {" "}
                            {searchTickets.invalidTicketCount}
                          </span>{" "}
                          بلیط
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <Row className="text-orange">
                      <Col
                        xs="12"
                        sm
                        className="nowrap text-center my-auto fs-small-1"
                      >
                        <span className="small-svg mr-1">
                          <IconNoTicket />
                        </span>
                        کنسل شده
                      </Col>
                      <Col
                        xs="12"
                        sm
                        className="nowrap mt-3 mt-sm-0 text-center"
                      >
                        <div className="bg-orange py-1 rounded-2 mx-3 mx-sm-0">
                          <span className="fw-bold mx-1">
                            {searchTickets.cancelledTicketCount}
                          </span>{" "}
                          بلیط
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="border-top mt-4 pt-4 px-3">
                  <Row>
                    <Col xs="auto" className="pr-0">
                      <Form.Select
                        className="text-center"
                        style={{ width: "60px" }}
                        value={selectedCount}
                        onChange={handleSelectChange}
                      >
                        <option key={0} value={0}>
                          {0}
                        </option>
                        {/* Render options dynamically based on the number of persons */}
                        {searchTickets?.basketItemPersons?.map((_, index) => (
                          <option key={index} value={index + 1}>
                            {index + 1}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    {searchTickets.basketItemPersons?.length ? (
                      <Col xs className="pl-2 my-auto">
                        <div>
                          عدد بلیط {searchTickets.isEvent && <><span className="fw-bold">{searchTickets?.hallEventTitle}</span> - <span className="fw-bold">{searchTickets?.hallName}</span></>} {searchTickets.isEvent ? "-" : "جهت استفاده در"} تاریخ
                          {` ${searchTickets.basketItemPersons[0].checkInDate}${searchTickets.isEvent ? " - ساعت " + searchTickets.executionTime : ""}`}
                        </div>
                      </Col>
                    ) : (
                      ""
                    )}
                  </Row>
                  <Row className="mt-3 gap-3">
                    {searchTickets?.basketItemPersons?.map((ticket, index) => (
                      <Col key={ticket.id} xs="auto" className="px-2">
                        <FormControlLabel
                          control={
                            searchTickets.isEvent ?
                              <div style={{ border: `1px solid ${checkedStatus[index] ? "#20c997" : "rgba(0,0,0,0.2)"}` }} className="rounded-lg py-4 px-3">
                                <div className="d-flex gap-1 align-items-center">
                                  <Checkbox
                                    checked={checkedStatus[index] || false} // استفاده از مقدار پیش‌فرض false اگر undefined بود
                                    onChange={() => handleCheckboxChange(index)}
                                    color="primary"
                                    className="pt-0 pb-2 pr-2 pl-0"
                                  />
                                  <div className="mb-1">
                                    {ticket.id}
                                  </div>
                                </div>
                                <div style={{ fontSize: 11 }} className="me-4">
                                  <span className="fw-bold ms-5">جایگاه صندلی:</span> {ticket.hallBlockName}
                                </div>
                                <div style={{ fontSize: 11 }} className="my-1 me-4">
                                  <span className="fw-bold ms-5">ردیف صندلی:</span> {ticket.hallRowName}
                                </div>
                                <div style={{ fontSize: 11 }} className="me-4">
                                  <span className="fw-bold ms-5">شماره صندلی:</span> {ticket.hallSeatName}
                                </div>
                              </div>
                              : <Checkbox
                                checked={checkedStatus[index] || false} // استفاده از مقدار پیش‌فرض false اگر undefined بود
                                onChange={() => handleCheckboxChange(index)}
                                color="primary"
                              />
                          }
                          label={searchTickets.isEvent ? "" : ticket.id}
                        />
                      </Col>
                    ))}
                  </Row>
                  {!!diffrentPrice && diffrentPrice != 0 && !searchTickets.isEvent && <Row style={{ width: "fit-content" }}>
                    <div style={{ fontSize: 12 }} className="d-flex gap-1 text-end bg-light-warning p-2 rounded-2 mt-2">
                      <div className="text-warning">
                        <IconInfo />
                      </div>
                      بلیط ها در تاریخ {createdPersianTime} خریداری شدند و هر بلیط مبلغ {tools.formatPriceNumber(diffrentPrice)} تومان تغییر نرخ دارند
                    </div>
                  </Row>}
                  {diffrentDate.isDiffrent && <Row style={{ width: "fit-content" }}>
                    <div style={{ fontSize: 12 }} className="d-flex gap-1 text-end bg-light-warning p-2 rounded-2 mt-2">
                      <div className="text-warning">
                        <IconInfo />
                      </div>
                      تاریخ و زمان استفاده بلیط ها {diffrentDate.checkInDate} بوده است
                    </div>
                  </Row>}
                  <Row className="mt-3 pb-2">
                    <Col xs="auto" className="pr-0">
                      {loadingBtn ? (
                        <Button
                          variant="danger"
                          className="px-5 py-2"
                          onClick={cancelTicket}
                          ref={cancelButtonRef}
                          //ref={ref} // اینجا ref به Button منتقل می‌شود
                          disabled
                        >
                          <Spinner size="sm" />
                          ابطال بلیط
                        </Button>
                      ) : (
                        <Button
                          variant="danger"
                          className="px-5 py-2 pulse-btn"
                          onClick={cancelTicket}
                          ref={cancelButtonRef}
                          //ref={ref} // اینجا ref به Button منتقل می‌شود
                          disabled={selectedCount === 0}
                        >
                          ابطال بلیط
                        </Button>
                      )}
                    </Col>
                    <Col xs="auto" className="pl-2">
                      <Button
                        variant="outline-danger"
                        className="px-4 py-2 "
                        onClick={handleCancel}
                      >
                        انصراف
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Card.Body>
            </Card>
          )}
        </>
      ) : (
        ""
      )}

      {/* <hr className="border-dark" /> */}
      <div className="pt-5"></div>
      <div className="fw-bold mb-4 mt-5">آخرین بلیط های استفاده شده</div>
      {loadingLastTicket ? (
        <div className=" bg-white border rounded-3 p-5 shadow-sm mx-auto">
          <LoaderDot text="در حال دریافت اطلاعات" />
        </div>
      ) : (
        <div>
          <Accordion className="acc" defaultActiveKey={["0"]} flush>
            {tickets?.map((item, index) => (
              <Accordion.Item
                eventKey={index.toString()}
                key={index}
                className="mb-2 rounded-3 border"
              >
                <TickeInfoBox item={item} />
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      )}
    </>
  );
}
export default TicketSearch;
